import React from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@material-ui/core'
import { useForm } from '../../forms'
import { ExportCall, ExportFilters } from 'src/services/skuit/types'

interface FormData {
  fields: { [field: string]: boolean }
}

interface ExportProps {
  name: string
  download: ExportCall
  fields: string[]
  open: boolean
  handleClose: () => void
  exportFilters?: ExportFilters
}

export const ExportDialog = (props: ExportProps) => {
  const { name, download, fields, open, handleClose, exportFilters } = props
  const { Form, Field } = useForm()
  const obj: { [field: string]: boolean } = {}
  const initial = fields.reduce((obj, field) => {
    obj[field] = true
    return obj
  }, obj)

  const onSubmit = (data: FormData) => {
    const fields = []
    for (const field in data.fields) {
      if (data.fields[field]) {
        fields.push(field)
      }
    }
    download({ fields: fields, exportFilters: exportFilters})
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Export {name}</DialogTitle>
      <Form onSubmit={onSubmit}>
        <DialogContent>
          <Field
            name="fields"
            defaultValue={initial}
            renderField={({ name, value, setValue }) => (
              <>
                <Typography>Select fields to include in export</Typography>
                {fields.map((fieldName: string) => (
                  <FormControlLabel
                    key={fieldName}
                    control={
                      <Checkbox
                        name={fieldName}
                        checked={value ? value[fieldName] || false : false}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          setValue(name, { ...value, [event.target.name]: event.target.checked })
                        }}
                      />
                    }
                    label={fieldName}
                  />
                ))}
              </>
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" autoFocus>
            Download
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
